import React from "react";
export var DrawerContext = React.createContext({
    mobileOpen: false,
    handleDrawerToggle: function () { },
    setMobileOpen: function () { },
});
